module.exports = __webpack_public_path__ + "static/media/yohannes.18a17d77.png";